// extracted by mini-css-extract-plugin
export default {"home":"home_home__rh0nU","home_item":"home_home_item__gqyVR","item_header":"home_item_header__MZz5I"};